module.exports = __webpack_public_path__ + "static/img/card1.f55fd034.png";